// third-party
import StencilBox from '../stencils/StencilBox';
import { useProductContext } from '../../context/product_context';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';

const EBookListingHomeStencil = ({ data, classes }) => {

    const { ebooks } = useProductContext();

    return (
        <div className="edu-course-area eduvibe-home-two-course course-three-wrapper edu-section-gap bg-color-white sf-stencil-bg">
            <div className="container eduvibe-animated-shape">
                <div className="row g-5 align-items-center mb--45 mb--30 mt_md--30 mt_sm--30">
                    <div className="col-lg-6">
                        <StencilBox
                            className="pre-title stencil-sm-devic mb--10"
                            width="50%"
                            height="26px"
                            backgroundColor="#F5F5F5"
                        />
                        <StencilBox
                            className="pre-title stencil-sm-devic"
                            width="90%"
                            height="56px"
                            backgroundColor="#F5F5F5"
                        />
                    </div>
                    <div className="col-lg-6">
                        <div className="pricing-billing-duration">
                            <Link className="edu-btn-stencil">
                                <StencilBox
                                    className="sf-blog-btn-stencil"
                                    width="223px"
                                    height="60px"
                                    backgroundColor="#F5F5F5"
                                />
                            </Link>
                        </div>
                    </div>
                </div>

                <div
                    className="overflow-hidden js-section-slider"
                    data-loop
                    data-gap="30"
                    data-pagination
                    data-slider-cols="xl-6 lg-6 md-4 sm-3 base-2"
                >
                    {/* {showSlider && ( */}
                    <Swiper
                        // {...setting}

                        modules={[Navigation, Pagination]}
                        pagination={{
                            el: ".books-pagination",
                            clickable: true,
                        }}
                        navigation={{
                            nextEl: ".books-next",
                            prevEl: ".books-prev",
                        }}
                        spaceBetween={30}
                        slidesPerView={2}
                        breakpoints={{
                            // when window width is >= 576px
                            450: {
                                slidesPerView: 3,
                            },
                            // when window width is >= 768px
                            768: {
                                slidesPerView: 4,
                            },
                            1200: {
                                // when window width is >= 992px
                                slidesPerView: 6,
                            },
                        }}
                        loop={true}
                    >
                        {ebooks?.map((item, i) => (
                            <SwiperSlide key={i}>
                                <div className="">
                                    <div
                                        className={`edu-card card-type-3 radius-small bg-color-white ${classes ? classes : ""}`}
                                    >
                                        <div className="inner">
                                            <div className="thumbnail ebook-img-height placeholder placeholder-glow "/>

                                            <div className="content p-2">
                                                <h6 className="title placeholder-glow">
                                                    <span className="placeholder w-100"></span>
                                                </h6>

                                                <div className="price-list price-style-03 p-2">
                                                    <StencilBox

                                                        width="100px"
                                                        height="50px"
                                                        backgroundColor="#231f40"
                                                    />
                                                </div>
                                                <h6 className="title placeholder-glow">
                                                    <span className="placeholder w-50"></span>
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            // 140,90
                        ))}
                    </Swiper>
            
                </div>
            </div>
        </div>
    )
}

export default EBookListingHomeStencil;